import MembershipOfferingModel from "src/models/MembershipOfferingModel";
import { RecurringCreditModel } from "src/models/RecurringCreditModel";
import { CustomerServiceItemType } from "types/code-generator";
import { UsaSwimmingImport } from "types/usa-swimming";
import EvaluationModel from "./EvaluationModel";
import { RecurringChargeModel } from "./RecurringChargeModel";
import UserModel from "./UserModel";

export const isCustomerServiceItem = (
  customerServiceItem
): customerServiceItem is CustomerServiceItemModel =>
  customerServiceItem instanceof CustomerServiceItemModel;

export class CustomerServiceItemModel {
  id: string;
  createdAt: Date;
  evaluation: EvaluationModel;
  integration: UsaSwimmingImport;
  membershipOffering: MembershipOfferingModel;
  recurringCharge: RecurringChargeModel;
  recurringCredit: RecurringCreditModel;
  type: CustomerServiceItemType;
  unread: boolean;
  user: UserModel;
  value: string;

  constructor(data: Partial<CustomerServiceItemModel>) {
    Object.assign(this, data);
  }
}
